import { Typography } from '@mui/material';
import { tss } from 'tss-react/mui';

interface Props {
  className?: string | null | undefined;
}

const useStyles = tss.create({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '10em',
  },
});

export const FileManagerEmptyFolder = ({ className }: Props) => {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(className, classes.root)}>
      <Typography variant="h6">
        This folder hasn&apos;t got any files in it
      </Typography>
      <Typography variant="caption">
        Drag files and folders here to upload them
      </Typography>
    </div>
  );
};
